import { Component } from '@angular/core'

@Component({
  selector: 'kit-bootstrap-form-example',
  templateUrl: './form.component.html',
})
export class KitBootstrapFormExampleComponent {}
